export enum retrievalModeEnum {
  INCREMENTAL_MODE = 'incrementalMode',
  ALL = 'all',
}
